import React from "react";

const ContactAreaThree = () => {
  return (
    <>
      {/* ========================= contact Area Three start =========================*/}
      <div className='price-process-area pd-top-120'>
        <div className='contact-inner-1 contact-inner-2'>
          <div className='row'>
            <div
              className='col-lg-6 '
              data-aos='fade-right'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
              <img className='w-100' src='assets/img/about/12.png' alt='img' />
            </div>
            <div
              className='col-lg-4'
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mb-0'>
                <h6 className='sub-title'>GET IN TOUCH</h6>
                <h2 className='title mb-4'>
                  Smarter Applications For The <span>Smarter</span> Individuals
                </h2>
                <div className='media mb-3'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Felis in quam volutpat </h5>
                    <p className='mb-0'>
                      Lorem ipsum dolor consectetur notte massa sapien samet.
                      Aucibus sed sem non, mattis commodo nisi.
                    </p>
                  </div>
                </div>
                <div className='media mb-3'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Sed mi et in neque mattis</h5>
                    <p className='mb-0'>
                      Lorem ipsum dolor consectetur notte massa sapien samet.
                      Aucibus sed sem non, mattis commodo nisi.
                    </p>
                  </div>
                </div>
                <div className='media'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Commodo adipiscing </h5>
                    <p className='mb-0'>
                      Lorem ipsum dolor consectetur notte massa sapien samet.
                      Aucibus sed sem non, mattis commodo nisi.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*========================= contact-inner Three end =========================*/}
    </>
  );
};

export default ContactAreaThree;
